import { render, staticRenderFns } from "./NewsSwiper.vue?vue&type=template&id=dc253370"
import script from "./NewsSwiper.vue?vue&type=script&lang=js"
export * from "./NewsSwiper.vue?vue&type=script&lang=js"
import style0 from "./NewsSwiper.vue?vue&type=style&index=0&id=dc253370&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports